import { functions } from "@/lib/firebase";
import { SearchResponseItem } from "@/lib/SemanticScholarApi";
import { httpsCallable } from "firebase/functions";

type GetPapersRequest = {
  token: string;
};

type GetPapersResponse = {
  status: boolean;
  papers: Array<SearchResponseItem>;
};

/**
 * Get papers by archie token
 */
const getPapers = httpsCallable<GetPapersRequest, GetPapersResponse>(
  functions,
  "get_papers"
);

export { getPapers };
